import initialState from './initialState';
import {
  NOTIFICATION,
  RESET_HEADER,
  SET_REPEAT_TOUR_ACTION
} from '../../actions/header/types';
import { deleteLocalState } from '../../store/localStorage.js'

export default function header(state = initialState, action) {
  switch (action.type) {
    case NOTIFICATION:
      return{
        ...state,
        notification: action.payload.notification,
        task: action.payload.task,
        user: action.payload.user,
        help: action.payload.help,
      };
    case RESET_HEADER:
      return{
        ...state,
        notification: false,
        task: false,
        user: false,
        help: false,
        helpRepeatTourAction: null
      };
    case SET_REPEAT_TOUR_ACTION:
      return{
        ...state,
        helpRepeatTourAction: action.payload.action
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./source/client/reducers/header/index.js